import { useShallow } from 'zustand/react/shallow'

import { STORE_STATUS } from '@/constants/store'
import { usePastProvisionStore } from '@/stores/pipelineCheck'

import { FilterableTable } from '../table/base'
import {
  PIPELINE_PAST_PROVISION_HEADERS,
  pipelinePastProvisionFilters
} from './pastProvision.table'
import { PIPELINE_NO_DATA } from './utils'

const tableId = 'pipeline-past-provision-table'

export const PipelineCheckPastProvisionTable = () => {
  const { data, isFetching, isLoading } = usePastProvisionStore(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching
    }))
  )

  return (
    <FilterableTable
      data={data}
      tableId={tableId}
      loading={isLoading}
      fetching={isFetching}
      columns={PIPELINE_PAST_PROVISION_HEADERS}
      noDataMessage={PIPELINE_NO_DATA}
      filters={pipelinePastProvisionFilters}
      clientSideFilters
      clientSideSortAndPagination
    />
  )
}
